/* eslint-disable max-len */
import React, { useRef } from 'react'
import { useOnClickOutside } from '../../CommonMethods/OutsideClick'

const DescriptionModal = ({descriptionModal, setDescriptionModal, description}) => {
    const clickOutSide = useRef()
    useOnClickOutside(clickOutSide, () => {
        setDescriptionModal(false);
    });
    return (
        <div data-te-modal-init  class={`fixed left-0 top-0 z-[1055] bg-[#00000047]  ${descriptionModal ? '' : 'hidden'} h-full w-full overflow-y-auto overflow-x-hidden outline-none`} id="descriptionModal" tabindex="-1" aria-labelledby="descriptionModal" aria-modal="true" role="dialog">
            <div ref={clickOutSide} data-te-modal-dialog-ref class="pointer-events-none relative flex min-h-[calc(100%-1rem)] w-auto translate-y-[-50px] items-center opacity-1 transition-all duration-300 ease-in-out min-w-[390px] mx-auto max-w-[390px]">
                <div class="pointer-events-auto relative flex w-full flex-col rounded-md border-none bg-white bg-clip-padding text-current shadow-lg outline-none dark:bg-neutral-600 min-w-[390px] mx-auto max-w-[390px] p-5">
                    <div class="flex flex-shrink-0 items-center justify-end rounded-t-md">
                        <button 
                            type="button" 
                            class="box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none"
                            data-te-modal-dismiss aria-label="Close"
                            onClick={() => setDescriptionModal(false)}
                        >
                            <img loading="lazy" decoding="async" src="/images/modalClose.svg" alt="icon" />
                        </button>
                    </div>
                    <div>
                        <p class="text-xl font-medium text-[#031624] text-center">Description</p>
                        <div class="pl-1 max-h-[200px] overflow-auto scroll-smooth scroll-bar pt-2">
                            <div class="pl-2">
                                <p class="text-center">
                                    {description}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DescriptionModal